import * as React from 'react';

import * as styles from './BookingCalendarLayout.css';

interface IBookingCalendarLayoutProps {
  children: React.ReactNode;
  ref?: React.Ref<HTMLDivElement>;
}

export function BookingCalendarLayout({ children, ref }: IBookingCalendarLayoutProps) {
  return (
    <div className={styles['root']} ref={ref}>
      {children}
    </div>
  );
}
